function getDocHeight() {
	'use strict';
	var D = document;
	return Math.max(
		Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
		Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
		Math.max(D.body.clientHeight, D.documentElement.clientHeight)
	);
}

function reSize(e) {
	'use strict';
	var eOffset = null;
	eOffset = e ? e : 0;
	//We have to set the bodyframe to a low value or else the resize functionality will not work
	window.top.reSizeBodyFrame(100);
	window.top.reSizeBodyFrame(getDocHeight() + eOffset);
}
;
define("legacy/resize", function(){});

